module.exports = __webpack_public_path__ + "img/card5.59ede443.png";